import React from "react";
import { trustPoints } from "./landingContent";

export default function LandingTrust() {
  return (
    <section className="hr-landing-section hr-landing-section--muted" aria-labelledby="hr-landing-trust-title">
      <div className="home-page__container">
        <header className="hr-landing-section__head hr-landing-section__head--center">
          <h2 id="hr-landing-trust-title" className="hr-landing-section__title">
            אמון — בלי מספרים מומצאים
          </h2>
          <p className="hr-landing-section__lead hr-landing-section__lead--narrow">
            אנחנו לא מציגים כאן ספירת סוכנים או מחזורים שלא מאומתים מולכם. כן מפרטים מה בונה אמון במוצר.
          </p>
        </header>
        <ul className="hr-landing-trust-grid">
          {trustPoints.map((t, i) => (
            <li key={i} className="hr-landing-trust-card">
              <h3 className="hr-landing-trust-card__title">{t.title}</h3>
              <p className="hr-landing-trust-card__text">{t.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
